import React from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";
import { toFixed } from "@common/util/format";
/*eslint-disable */

const BrewWater = ({ batchSize, preMixWater, totalWater, kettleWater }) => {
  const batchSizeDescription =
    "Currently the MiniBrew Portal only allows you to create 5.5L batches.";
  const totalWaterDescription =
    "This is the total amount of drinkable water that will be added to the beer during mashing preparation, and brewers will need for brewing.";
  const kettleWaterDescription =
    "This is the amount of water that will be added to the Keg during mash preparation. It is equal to the Total Water minus the Pre-Mix Water.";
  const preMixWaterDescription =
    "This is the amount of water that will be mixed into the dry grains, it is equal to 1 L per 1.6 kg of grains.";
  const popOver = (content) => (
    <Popover id="popover-trigger-hover-focus">{content}</Popover>
  );
  const Trigger = ({ children, content }) => (
    <OverlayTrigger
      trigger={["hover", "focus", "click"]}
      placement="bottom"
      overlay={popOver(content)}
    >
      {children}
    </OverlayTrigger>
  );
  const items = [
    {
      label: "Batch Size",
      content: batchSizeDescription,
      value: `${toFixed(batchSize - 0.5)} L`,
    },
    {
      label: "Kettle Water Addition",
      content: kettleWaterDescription,
      value: `${toFixed(kettleWater)} L`,
    },
    {
      label: "Pre-Mix Water Addition",
      content: preMixWaterDescription,
      value: `${toFixed(preMixWater)} L`,
    },
    {
      label: "Total water",
      content: totalWaterDescription,
      value: `${toFixed(totalWater)} L`,
    },
  ];

  return (
    <div className="minibrew-container">
      <h2
        style={{
          fontWeight: "normal",
          fontFamily: "Gotham-Bold",
          marginTop: "3px",
        }}
      >
        Brew water
      </h2>

      <div className="row">
        <div className="col-md-6 col-sm-12">
          <p style={{ fontWeight: "normal", fontFamily: "Gotham-Book" }}>
            These values are calculated automatically based on the fermentables
            you include in your mash stage(s).
          </p>
        </div>
        <div className="col-md-6 col-sm-12">
          <div
            className="brew-water-items"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              marginTop: "4px",
            }}
          >
            {items.map((item, idx) => (
              <div
                key={idx}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  gap: "16px",
                }}
              >
                <Trigger content={item.content}>
                  <p style={{ margin: 0, cursor: "pointer" }}>
                    {item.label} <span className="ion-help-circled" />
                  </p>
                </Trigger>
                <p
                  style={{
                    margin: 0,
                    flexShrink: 0,
                    textAlign: "right",
                    fontFamily: "Gotham-Medium",
                    fontWeight: "bold",
                  }}
                >
                  {item.value}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
/*eslint-enable */
export default BrewWater;
